import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { ReactNode, useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

// Verndale customization ticket: DSSM-407
const mapStateToProps = (state: ApplicationState) => {
    const { session } = state.context;
    return {
        page: getCurrentPage(state),
        isAuthenticated: session.isAuthenticated,
    };
};
// End of Verndale customization ticket: DSSM-407

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// Verndale customization ticket: DSSM-407
type Props = PageLayoutProps & ReturnType<typeof mapStateToProps>;
// End of Verndale customization ticket: DSSM-407

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
    isAuthenticated,
    page,
}: Props) => {
    // Verndale customization ticket: DSSM-407

    useEffect(() => {
        if (page && page?.name !== "") {
            const authenticationState = isAuthenticated ? "Logged_in" : "Not_logged_in";
            setGA4Event([], "authentication_state", { authenticationState });
        }
    }, [page, isAuthenticated]);
    // End of Verndale customization ticket: DSSM-407

    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div">
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;
// Verndale customization ticket: DSSM-407
export default connect(mapStateToProps)(PageLayout as any);
// End of Verndale customization ticket: DSSM-407
